import React from "react";
import MarketWatchIndexStrip from "components/MarketWatch/MarketWatchIndexStrip";

export default function MarketWatchIndexShow({ expandMore, scriptIndexList }) {
  return (
    <div className={expandMore ? "toggle_btn_wrap show mb-2" : "toggle_btn_wrap"}>
      <MarketWatchIndexStrip scriptIndexList={scriptIndexList} className="mnifty_wrapper" />
    </div>
  );
}
